/**
 * Used with use-push-to-talk-caps-lock.ts
 */
export const isMacOS =
  typeof navigator !== 'undefined' &&
  navigator.platform.toUpperCase().includes('MAC');